import { render, staticRenderFns } from "./DeleteContactWindow.vue?vue&type=template&id=765b9b9a&scoped=true"
import script from "./DeleteContactWindow.vue?vue&type=script&lang=js"
export * from "./DeleteContactWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765b9b9a",
  null
  
)

export default component.exports